<script>
export default {
  name: 'SaleProgressBar',
  props: {
    currentStage: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    progressColor() {
      return this.$chain.getName() === 'ethereum' ? '#FF7979' : '#EDCF38';
    },
    percent() {
      return this.product.isFinished ? this.product.progress : this.info.percent;
    },
  },
};
</script>

<template>
  <div class="upcoming-card__progress" v-if="currentStage > 2">
    <v-row justify="end" class="progress__title mb-2">
      <v-col sm="4" xs="12" class="text-center font-weight-bold">
        {{ $t('upcoming.tokens-sold') }}
      </v-col>
      <v-col sm="4" xs="12" class="text-right font-weight-bold">
        {{ $t('upcoming.total') }}
      </v-col>
    </v-row>
    <v-progress-linear
      class="mb-4"
      :class="{ 'afterhalf' : percent > 50 }"
      :color="progressColor"
      background-color="#FBF0ED"
      rounded
      :value="percent"
      height="38"
    >
      <span>{{ percent.toFixed(1) }}%</span>
    </v-progress-linear>
    <v-row justify="between" class="progress__subtitle mb-2">
      <v-col sm="6" xs="12" class="text-left"> 0 {{ info.token || '...' }} </v-col>
      <v-col sm="6" xs="12" class="text-right">
        <p>
          {{ $BN(isNaN(info.tokenAmount) ? 0 : info.tokenAmount) | amount(4) }}
          {{ info.token || '...' }}
        </p>
        <p>
          {{
            $BN(isNaN(info.tokenAmount) ? 0 : info.tokenAmount).times(info.tokenPrice) | amount(4)
          }}
          {{ info.paymentToken || '...' }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss"></style>
